<div class="dialog-content-wrapper">
  <mat-toolbar class="mat-accent m-0">
    <mat-toolbar-row fxFlex fxLayout="row" fxLayoutAlign="space-between center">
      <span class="title dialog-title">{{ "Search" | translate }}... </span>
      <button
        mat-icon-button
        (click)="matDialogRef.close()"
        aria-label="Close dialog"
      >
        <mat-icon>close</mat-icon>
      </button>
    </mat-toolbar-row>
  </mat-toolbar>

  <mat-tab-group>
    <mat-tab label="{{ 'Members' | translate }}">
      <div mat-dialog-content class="p-16 pb-0 m-0" fusePerfectScrollbar>
        <form class="example-form">
          <mat-form-field class="example-full-width mt-12" appearance="outline">
            <input
              #myInput
              (keyup)="OnInput(myInput.value)"
              type="text"
              placeholder="{{ 'Members' | translate }}"
              aria-label="Number"
              matInput
              class="font-weight-900"
            />
            <mat-icon
              style="cursor: pointer"
              class="search"
              matSuffix
              *ngIf="!isWait"
              (click)="searchClick(myInput.value)"
              >search</mat-icon
            >
            <mat-spinner matSuffix diameter="20" *ngIf="isWait"></mat-spinner>
          </mat-form-field>
        </form>
        <div *ngFor="let uripinar of uripinarList">
          <div fxFlex="100" *ngIf="list">
            <mat-card
              class="example-card"
              (click)="getUripinar(uripinar)"
              style="width: 100%; cursor: pointer"
            >
              <mat-card-header>
                <div
                  mat-card-avatar
                  class="example-header-image"
                  style="width: 65px !important; height: 65px !important"
                >
                  <img
                    (error)="showEmptyProfile($event)"
                    src="{{ uripinar.photo_url }} "
                    width="80px"
                    style="height: 100%"
                  />
                </div>
                <mat-card-title class="ml-12">{{
                  uripinar.name
                }}</mat-card-title>
                <mat-card-subtitle class="ml-12">{{
                  uripinar.member_id
                }}</mat-card-subtitle>
                <mat-card-subtitle *ngIf="uripinar.address" class="ml-12">{{
                  uripinar.address
                }}</mat-card-subtitle>
              </mat-card-header>
            </mat-card>
          </div>
        </div>
        <button
          *ngIf="showMore"
          style="float: right"
          (click)="seeMore(myInput.value)"
          mat-raised-button
          color="accent"
        >
          See More
        </button>
      </div>
    </mat-tab>
    <!-- <mat-tab label="{{ 'recently joined' | translate }}">
      <div mat-dialog-content class="p-16 pb-0 m-0" fusePerfectScrollbar>
        <form class="example-form">
          <mat-form-field class="example-full-width" appearance="outline">
            <input
              #myInput
              (keyup)="OnInput(myInput.value)"
              type="text"
              placeholder="{{ 'recently joined' | translate }}"
              aria-label="Number"
              matInput
            />
          </mat-form-field>
          <div *ngFor="let uripinar of uripinarList">
            <div fxFlex="100">
              <mat-card
                class="example-card"
                style="width: 100%"
                (click)="getUripinar(uripinar)"
              >
                <mat-card-header>
                  <div
                    mat-card-avatar
                    class="example-header-image"
                    style="width: 65px !important; height: 65px !important"
                  >
                    <img
                      (error)="showEmptyProfile($event)"
                      src="{{ uripinar.photo_url }} "
                      width="80px"
                      style="height: 100%"
                    />
                  </div>
                  <mat-card-title class="ml-12">{{
                    uripinar.name
                  }}</mat-card-title>
                  <mat-card-subtitle class="ml-12">{{
                    uripinar.member_id
                  }}</mat-card-subtitle>
                </mat-card-header>
              </mat-card>
            </div>
          </div>
        </form>
      </div>
    </mat-tab> -->
  </mat-tab-group>

  <!-- <div mat-dialog-actions class="m-0 p-16" fxLayout="row" fxLayoutAlign="end center">

        <button *ngIf="action !=='edit'"
                mat-button color="primary"
                class="mr-8"
                (click)="matDialogRef.close(['delete',eventForm])"
                aria-label="Delete"
                matTooltip="Delete">
                ரத்து
        </button>

  <div
    mat-dialog-actions
    class="m-0 p-16"
    fxLayout="row"
    fxLayoutAlign="end center"
  >
    <button
      *ngIf="action !== 'edit'"
      mat-button
      color="primary"
      class="mr-8"
      (click)="matDialogRef.close(['delete', eventForm])"
      aria-label="Delete"
      matTooltip="Delete"
    >
      ரத்து
    </button>

    <button
      *ngIf="action === 'edit'"
      mat-button
      color="primary"
      class="save-button"
      (click)="matDialogRef.close(eventForm)"
      [disabled]="eventForm.invalid"
      aria-label="ADD"
    >
      One
    </button>

    </div> -->
</div>
